import * as actions from './../actions/actionConstants.js';

const initialState = {
	teams: {},
	teamsList: [],
	fetchingTeamVolunteerDataStatus: '',
	seasonUmpires : {},
	seasonUmpiresList: [],
	fetchingSeasonUmpireDataStatus: '',
	seasons: {},
	seasonsList: [],
	fetchingYtdSummaryDataStatus: '',
	wheelUmpires: {},
	wheelUmpiresList: [],
	fetchingWheelDataStatus: '',
	statsSeasons: {},
	statsSeasonsList: [],
	umpiresStats: {},
	umpiresStatsList: [],
	fetchingFullSeasonStatsStatus: '',
	umpireStats: {},
	fetchingUmpireStatsStatus: '',
	error: ''
};

const reportsReducer = (state = initialState, action) => {
	switch(action.type){
		case actions.GET_SEASON_UMPIRE_DATA:
				return{
					...state,
					fetchingSeasonUmpireDataStatus: 'Loading'
				};
		case actions.GET_SEASON_UMPIRE_DATA_SUCCESS:
				return{
					...state,
					seasonUmpires: {...action.umpires},
					seasonUmpiresList: [...action.umpiresList],
					fetchingSeasonUmpireDataStatus: 'Loaded'
				};
		case actions.GET_SEASON_UMPIRE_DATA_ERROR:
			return{
				...state,
				error: action.error,
				fetchingSeasonUmpireDataStatus: 'Error'
			};
		case actions.GET_YTD_DATA:
			return{
				...state,
				fetchingYtdSummaryDataStatus: 'Loading'
			};
		case actions.GET_YTD_DATA_SUCCESS:
			return{
				...state,
				seasons: {
					...action.seasons
				},
		        seasonsList: [
		        	...action.seasonsList
        		],
				fetchingYtdSummaryDataStatus: 'Loaded'
			};
		case actions.GET_YTD_DATA_ERROR:
			return{
				...state,
				error: action.error,
				fetchingYtdSummaryDataStatus: 'Error'
			};
		case actions.GET_WHEEL_DATA:
			return{
				...state,
				fetchingWheelDataStatus: 'Loading'
			};
		case actions.GET_WHEEL_DATA_SUCCESS:
			return{
				...state,
				wheelUmpires: {
					...action.wheelUmpires
				},
				wheelUmpiresList: [
					...action.wheelUmpiresList
				],
				fetchingWheelDataStatus: 'Loaded'
			};
		case actions.GET_WHEEL_DATA_ERROR:
			return{
				...state,
				error: action.error,
				fetchingWheelDataStatus: 'Error'
			};
		case actions.GET_FULL_SEASON_STATS:
			return{
				...state,
				statsSeasons: {},
				statsSeasonsList: [],
				umpiresStats: {},
				umpiresStatsList: [],
				fetchingFullSeasonStatsStatus: 'Loading'
			};
		case actions.GET_FULL_SEASON_STATS_SUCCESS:
			return{
				...state,
				statsSeasons: {
					...action.seasons
				},
				statsSeasonsList: [
					...action.seasonsList
				],
				umpiresStats: {
					...action.umpires
				},
				umpiresStatsList: [
					...action.umpiresList
				],
				fetchingFullSeasonStatsStatus: 'Loaded'
			};
		case actions.GET_FULL_SEASON_STATS_ERROR:
			return{
				...state,
				error: action.error,
				fetchingFullSeasonStatsStatus: 'Error'
			};
		case actions.GET_UMPIRE_STATS:
			return{
				...state,
				fetchingUmpireStatsStatus: 'Loading'
			};
		case actions.GET_UMPIRE_STATS_SUCCESS:
			return{
				...state,
				umpireStats: {
					...action.umpireStats
				},
				fetchingUmpireStatsStatus: 'Loaded'
			};
		case actions.GET_UMPIRE_STATS_ERROR:
			return{
				...state,
				error: action.error,
				fetchingUmpireStatsStatus: 'Error'
			};
		case actions.GET_TEAM_VOLUNTEER_DATA:
			return{
				...state,
				fetchingTeamVolunteerDataStatus: 'Loading'
			};
		case actions.GET_TEAM_VOLUNTEER_DATA_SUCCESS:
			return{
				...state,
				teams: {
		            ...action.teams
		          },
		        teamsList: [
		        	...action.teamsList
		        ],
						fetchingTeamVolunteerDataStatus: 'Loaded'
			};
		case actions.GET_TEAM_VOLUNTEER_DATA_ERROR:
			return{
				...state,
				error: action.error,
				fetchingTeamVolunteerDataStatus: 'Error'
			};
		default:
			return state;
	}
};

export default reportsReducer;



// WEBPACK FOOTER //
// ./src/reducers/reports.js